import config from '../config';

export default {
  ...config,
  eventScannerUrl: window.atleta?.eventScannerUrl || '',
  maxExportSize: {
    orders: 200000,
    contacts: 200000,
    purchases: 200000,
    registrations: 200000,
  },
};
